/* eslint-disable func-names */
/* eslint-disable no-extend-native */
export default function () {
    String.prototype.trimSpaces = function () {
        return this.replace(/^ +| +$/g, '');
    };
    String.prototype.trimSpacesInTheEnd = function () {
        return this.replace(/ +$/, '');
    };
    String.prototype.trimSpacesAtTheStart = function () {
        return this.replace(/^ +/, '');
    };
}
